import { render, staticRenderFns } from "./JagfxNavigation.vue?vue&type=template&id=3ddd48c2&"
import script from "./JagfxNavigation.vue?vue&type=script&lang=js&"
export * from "./JagfxNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports